// removed by extract-text-webpack-plugin
module.exports = {"page":"_2jVar","red":"_36K25"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ScriptsInfo.css
// module id = 864
// module chunks = 0